import { stockService } from "Dashboard/scenes/Stock/services/stock.service";
import { forwardRef, useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { IOption } from "Dashboard/domain/IOption";
import { hrsService } from "Dashboard/scenes/HighRiseSales/services/hrs.services";
import { convertIStatusToIOption } from "Dashboard/domain/IStatus";
import { useSelector } from "react-redux";
import { selectState, updateStatuses } from "Dashboard/scenes/HighRiseSales/scenes/Main/main.slice";
import { useAppDispatch } from "hooks/hooks";

interface SalesUnitStatusSelectProps {
  defaultValue: number;
  onChange?: (val: number | null) => void;
  customStyles: any;
  error: any;
}

const SalesUnitStatusSelect = forwardRef<any, any>((props: SalesUnitStatusSelectProps, ref) => {
  const { defaultValue, onChange, customStyles, error } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const [valueLocal, setValueLocal] = useState<IOption | null>(null);
  const [inputValue, setInputValue] = useState<string | null>(null);
  const { statuses } = useSelector(selectState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    setOptions(statuses.map(convertIStatusToIOption));
    setIsLoading(false)
  }, [statuses.length]);

  useEffect(() => {
    if (defaultValue) {
      const savedValue = options.find(({ value }) => value === defaultValue);
      setValueLocal(savedValue ?? null)
    }
  }, [options, defaultValue]);

  const handleChange = (newValue: IOption | null) => {
    setValueLocal(newValue);
    onChange?.(newValue ? newValue.value : null);
  };

  const createOption = async (statusName: string): Promise<IOption> => {
    try {
      const response = await hrsService.createSalesUnitStatus(statusName);
      dispatch(updateStatuses(response));
      return convertIStatusToIOption(response);
    } catch (err) {
      throw err;
    }
  };

  const handleCreate = async (statusName: string) => {
    try {
      setIsLoading(true);
      const newOption = await createOption(statusName.trim());
      setOptions([...options, newOption]);
      handleChange(newOption);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false)
    }
  };

  const formatCreate = (inputValue: string) => {
    return <p> Dodaj: {inputValue}</p>;
  };

  return (
    <CreatableSelect
      isClearable
      styles={customStyles}
      ref={ref}
      options={options}
      value={valueLocal}
      onChange={(val) => handleChange(val)}
      formatCreateLabel={formatCreate}
      onCreateOption={handleCreate}
      inputValue={inputValue ?? ''}
      onInputChange={setInputValue}
      onMenuClose={(() => setInputValue(null))}
      placeholder={""}
      isDisabled={isLoading}
      isLoading={isLoading}
      {...{ error: error }}
    />
  );
});

export default SalesUnitStatusSelect;
